import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import enUS from "./locales/en_US";
import ptBR from "./locales/pt_BR";

// Define available languages
export const languages = {
	en_US: { nativeName: "English" },
	pt_BR: { nativeName: "Português" },
};

export type LanguageKey = keyof typeof languages;

export const DEFAULT_LANGUAGE: LanguageKey = "pt_BR";

// Initialize i18next
i18next.use(initReactI18next).init({
	resources: {
		en_US: {
			translation: enUS,
		},
		pt_BR: {
			translation: ptBR,
		},
	},
	lng: DEFAULT_LANGUAGE,
	fallbackLng: DEFAULT_LANGUAGE,
	interpolation: {
		escapeValue: false, // React already escapes values
	},
});

export default i18next;
